<template>
	<div class="k-component -showcase">
		<ShowcaseItem v-for="itemData in showcaseData.items" :key="itemData.id" :item-data="itemData" />
	</div>
</template>

<script>
import ShowcaseItem from '@/components/ShowcaseItem.vue'

export default {
	name: 'Showcase',

	components: {
		ShowcaseItem
	},

	props: {
		showcaseData: {
			type: Object,
			required: true
		}
	}
}
</script>

<style lang="scss">
@import '@/assets/scss/_component-showcase.scss';
</style>
